import React from 'react';
import {BasicFieldCheckbox, BasicTextArea, BaasicFormControls, BaasicButton} from 'core/components';
import { defaultTemplate } from 'core/hoc';
import PropTypes from 'prop-types';
import { TaskComment } from 'application/schedule/components';

function TaskPreviewEditTemplate ({ taskPreviewEditView, t }) {
    const { form, task, userRoles, rootStore, modalParams, isDeliveryLink,deliveryTask } = taskPreviewEditView;

    let isUserAccountManager =  task && task.accountRep && rootStore.userStore.user.id == task.accountRep.userId;
    let isPayorRep = task && task.payorRep != null && rootStore.userStore.user.id == task.payorRep.userId;
    let isIntakeRep = task && task.intakeRep != null && rootStore.userStore.user.id == task.intakeRep.userId;
    let isDocumentRep = task && task.documentRep != null && rootStore.userStore.user.id == task.documentRep.userId;
    let isBillingRep = task && task.billingRep != null && rootStore.userStore.user.id == task.billingRep.userId;

    return (
        <React.Fragment>
            {task != null && 
            <React.Fragment>
                <div className="modal__header">
                    <h3 className='u-mar--bottom--sml'>{task.name}</h3>
                </div>
                <div className="modal__body">
                    <div className="u-display--ib form__group">
                        <BasicFieldCheckbox field={form.$('noSupply')} />
                    </div>

                    {!userRoles.includes("Purchasers") &&
                        <React.Fragment>
                            <div className="row">
                                <div className="form__group col col-sml-12 col-lrg-6">
                                    <div className="form__group__header">
                                        <div>
                                            <BasicFieldCheckbox field={form.$('isDoneIntake')} 
                                                disabled={!rootStore.permissionStore.hasPermission('calendarSection.update') && 
                                                !isUserAccountManager && !isIntakeRep} />
                                        </div>
                                        <div>
                                            <BasicFieldCheckbox
                                                field={form.$('isReminderIntake')}
                                                checkedIconClass="u-icon--flag--red"
                                                unCheckedIconClass="u-icon--flag" 
                                                />
                                        </div>
                                    </div>
                                    <BasicTextArea rows="3" field={form.$('intakeNote')} disabled={!rootStore.permissionStore.hasPermission('calendarSection.update') && !isIntakeRep && !isUserAccountManager} />
                                </div>

                                <div className="form__group col col-sml-12 col-lrg-6">
                                    <div className="form__group__header">
                                        <div>
                                            <BasicFieldCheckbox field={form.$('isDonePayor')} 
                                                disabled={!rootStore.permissionStore.hasPermission('calendarSection.update') && 
                                                !isUserAccountManager &&!isPayorRep} />
                                        </div>
                                        <div>
                                            <BasicFieldCheckbox 
                                                field={form.$('isReminderPayor')}
                                                checkedIconClass="u-icon--flag--red"
                                                unCheckedIconClass="u-icon--flag" 
                                                />
                                        </div>
                                    </div>
                                    <BasicTextArea rows="3" field={form.$('payorNote')} disabled={!rootStore.permissionStore.hasPermission('calendarSection.update') && !isPayorRep && !isUserAccountManager}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-sml-12 col-lrg-6">
                                    <div className="form__group__header">
                                        <div>
                                            <BasicFieldCheckbox field={form.$('isDoneDocument')} 
                                                disabled={!rootStore.permissionStore.hasPermission('calendarSection.update') && 
                                                !isUserAccountManager &&!isDocumentRep} />
                                        </div>
                                        <div>
                                            <BasicFieldCheckbox 
                                                field={form.$('isReminderDocument')}
                                                checkedIconClass="u-icon--flag--red"
                                                unCheckedIconClass="u-icon--flag" 
                                                />
                                        </div>
                                    </div>
                                    <BasicTextArea rows="3" field={form.$('documentNote')} disabled={!rootStore.permissionStore.hasPermission('calendarSection.update') && !isDocumentRep && !isUserAccountManager}/>
                                </div>

                                <div className="form__group col col-sml-12 col-lrg-6">
                                    <div className="form__group__header">
                                        <div>
                                            <BasicFieldCheckbox field={form.$('isDoneBiller')}
                                            disabled={!rootStore.permissionStore.hasPermission('calendarSection.update') && 
                                            !isUserAccountManager &&!isBillingRep} />
                                        </div>
                                        <div>
                                            <BasicFieldCheckbox 
                                                field={form.$('isReminderBiller')}
                                                checkedIconClass="u-icon--flag--red"
                                                unCheckedIconClass="u-icon--flag" 
                                                />
                                        </div>
                                    </div>
                                    <BasicTextArea rows="3" field={form.$('billingNote')} disabled={!rootStore.permissionStore.hasPermission('calendarSection.update') && !isBillingRep && !isUserAccountManager} />
                                </div>  
                            </div>
                            <div className="form__group">
                                <BasicTextArea rows="2" field={form.$('notes')} />
                            </div>

                            {isDeliveryLink && 
                                <React.Fragment>
                                    <div className="form__group">
                                        <BasicTextArea rows="2" field={form.$('deliveryNotes')} />
                                    </div>
                                    <div className="form__group">
                                        Order detail notes: {deliveryTask.orderingDetailNote != "" ? (<i className="u-mar--right--sml">{deliveryTask.orderingDetailNote}</i>) :"- "} 
                                        <span className='type--color--warning'>
                                            Backorder Notes: {deliveryTask.backorderNote != "" ? (<i>{deliveryTask.backorderNote} </i>) :"-"} 
                                        </span>
                                    </div>
                                </React.Fragment>
                            }
                        </React.Fragment>
                    }

                    {userRoles.includes("Purchasers") &&
                        <React.Fragment>
                            <div className="form__group">
                                <BasicTextArea field={form.$('orderingDetailNote')} />
                            </div>
                            <div className="form__group">
                                <BasicFieldCheckbox field={form.$('isOrderDone')} />
                            </div>
                        </React.Fragment>
                    }

                    {userRoles.includes("Purchasers") && form.$('isOrderDone').value &&
                        <div className="form__group">
                            <BasicTextArea field={form.$('backorderNote')} />
                        </div>
                    }

                    {task && <TaskComment facilityScheduleDateId={task.id} />}
                </div>

                <div className="modal__footer">
                    <BaasicFormControls form={form} onSubmit={form.onSubmit} disabled={form.submitting} label="Save"  className='btn btn--med btn--primary' />  
                    <BaasicButton
                        className='btn btn--med btn--light'
                        label={t('EDIT_FORM_LAYOUT.CANCEL')}
                        onClick={() => modalParams.data.clickCallback(task)}
                    />
                </div>
        </React.Fragment>
        }
    </React.Fragment>
    )
}

TaskPreviewEditTemplate.propTypes = {
    taskPreviewEditView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(TaskPreviewEditTemplate);